import { PhoneNumber } from "../../../../Utilities";
import { PhoneNumberFormat } from "../../../Format";
import { ScaledViewModal, ScaledViewModalProps } from "../../_General/ScaledViewModal";

export type PhoneNumberViewModalProps = Omit<ScaledViewModalProps, "children"> & {
	phoneNumber: Pick<PhoneNumber, "id" | "phoneNumber">;
};

export function PhoneNumberViewModal({ phoneNumber, ...props }: PhoneNumberViewModalProps) {
	return <ScaledViewModal {...props}>{PhoneNumberFormat.Fields.phoneNumber(phoneNumber.phoneNumber)}</ScaledViewModal>;
}
